import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="none"
					title={"CCIWA - WA Works"}
					image={require('./video.jpg')}
					// video={{ mp4: require('./video.mp4'), webm: require('./video.webm')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A major industrial directory needing an upgrade.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/cciwa.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi designed and built a state of the art website and smartphone app.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Website <a href="http://waworksdirectory.cciwa.com" target="_blank">waworksdirectory.cciwa.com</a></li>
									<li>Custom designed for visual impact</li>
									<li>Built on the React platform for lightning speed</li>
									<li>Responsive design to work on all devices</li>
									<li>Smartphone application iOS Android</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="CCIWA - WA Works" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="CCIWA - WA Works" width="100%" />
								<img src={require('./example-2.jpg')} alt="CCIWA - WA Works" width="100%" />
								<img src={require('./example-3.jpg')} alt="CCIWA - WA Works" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/CCIWA/index.js